<template>
  <div>
    <v-card>
      <v-card-title
        class="text-center justify-center py-6 px-sm-16 secondary flex-column flex-sm-row justify-sm-space-between"
      >
        <v-container>
          <v-row align="center" justify="center">
            <div
              class="font-weight-normal white--text pb-5 pb-sm-0"
              style="font-size:2rem !important"
            >
              Cash Position
            </div>

            <v-select
              outlined
              filled
              attach
              pill
              return-object
              v-model="selectedAccount"
              :items="accountList"
              item-text="displayText"
              item-value="accountID"
              class="account-select justify-center py-sm-6 px-sm-16 secondary flex-column flex-sm-row w-4"
              label="Accounts"
            ></v-select>

            <custom-date-picker
              defaultStartDate="04/10/2017"
              @startDateChanged="selectedDate = $event"
            ></custom-date-picker>
            <v-spacer></v-spacer>
            <v-btn @click="refreshCashPosition" color="primary">
              Refresh
            </v-btn>
          </v-row>
        </v-container>
      </v-card-title>
      <cash-position-component-fake-data
        :dailyPositions="dailyPositionsList"
      ></cash-position-component-fake-data>
    </v-card>
  </div>
</template>

<script>
import CashPositionService from "../services/cashPositionService";
import CashPositionComponentFakeData from "@/components/CashPositionComponentFakeData";

export default {
  mounted() {
    this.acquireAccountList();
  },
  data() {
    return {
      selectedAccount: null,
      selectedDate: null,
      accountList: [],
      dailyPositionsList: {},
    };
  },
  methods: {
    handleStartDateChanged(evt) {
      console.log(evt);
    },
    acquireAccountList() {
      this.$root.setBusy("getGenericListOfAccounts", "Loading list of accounts . . .");
      this.$store
        .dispatch("cashposition/getGenericListOfAccounts")
        .then((acctList) => {
          console.log(acctList);
          this.accountList = acctList;
          if (this.accountList.length) {
            this.selectedAccount = this.accountList[0];
            this.refreshCashPosition();
          }
        })
        .finally(() => {
          this.$root.removeBusy("getGenericListOfAccounts");
        });
    },
    async refreshCashPosition() {
      console.log("SELECTED ACCOUNT: ", this.selectedAccount);
      console.log("SELECTED DATE: ", this.selectedDate);
      if (this.selectedAccount == null || this.selectedDate == null) {
        this.$dialog.info({
          text: "You must select an ACCOUNT and DATE. . .",
          title: "Heads up!",
        });
        return false;
      }

      this.$root.setBusy("getOpeningBalances", "Loading list of opening balances . . .");
      let positions = await this.$store.dispatch("cashposition/getOpeningBalances", {
        accountId: this.selectedAccount.accountID,
        startDate: this.selectedDate,
      });

      console.log("BALANCES SON: ", positions);
      this.dailyPositionsList = CashPositionService.generateCashPosition(this.selectedDate);
      console.log("GENERATED POSITION:", this.dailyPositionsList);
      this.$root.removeBusy("getOpeningBalances");
    },
  },
  computed: {
    // accountList() {
    //   return this.$store.getters["cashposition/cashPositionAccounts"];
    // },
  },
  components: {
    CashPositionComponentFakeData,
  },
};
</script>

<style lang="scss">
.account-select fieldset {
  background-color: white !important;
}
</style>
